import { WithRequestDemo } from "../contact-modal/WithContactUsAttributes";

const CarouselIndicators = ({ images, carouselId }) => (
    <div className="carousel-indicators">
        {images.map((image, index) => (
            <button
                type="button"
                key={index}
                data-bs-target={'#' + carouselId}
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current="true"
                aria-label={"Slide " + index}
            />
        ))}
    </div>
);

const CarouselItems = ({ images }) => (
    <div className="carousel-inner">
        {images.map((image, index) => (
            <div key={index} className={"carousel-item " + (index === 0 ? "active" : "")}>
                <img src={image} className="d-block w-100" alt="..." />
            </div>
        ))}
    </div>
);

const CarouselMessage = ({ message }) => (
    message && (
        <div className="carousel-title">
            <h1 className="header d-none d-md-inline-block">{message.title}</h1>
            <p className="description d-none d-lg-inline-block">{message.description}</p>
            {message.button && (
                message.button.type === 'contact-us' ? (
                    <button
                        className="btn btn-primary get-started-button d-none d-sm-inline-block"
                        {...WithRequestDemo()}
                    >
                        {message.button.text}
                    </button>
                ) : (
                    <button className="btn btn-primary get-started-button d-none d-sm-inline-block">
                        {message.button.text}
                    </button>
                )
            )}
        </div>
    )
);

const SideBoxItem = ({ item }) => {
    const getTypeDisplayName = (type) => {
        switch (type) {
            case 'event':
                return 'Event';
            case 'release':
                return 'Product Release';
            default:
                return 'News';
        }
    };

    const handleLinkClick = (e) => {
        if (item.type === 'event') {
            e.preventDefault();
            // Open modal for event type news
            const button = document.createElement('button');
            button.setAttribute('data-bs-toggle', 'modal');
            button.setAttribute('data-bs-target', '#newsDetailModal');
            button.setAttribute('data-news', JSON.stringify({
                title: item.text,
                date: item.date,
                type: item.type,
                shortDescription: item.shortDescription || "September 15-2025 Digital Facilities will be attending the MEHEC EXPO on Thursday. Join us at this important industry event to learn about our latest building management solutions and innovations."
            }));
            button.style.display = 'none';
            document.body.appendChild(button);
            button.click();
            document.body.removeChild(button);
        }
    };

    return (
        <div className="side-box-item">
            {item.image && (
                <div className="side-box-image">
                    <img src={item.image} alt="..." />
                </div>
            )}
            <div className="side-box-item-content">
                <div className="side-box-item-header">
                    {item.type && (
                        <span className="side-box-item-type">{getTypeDisplayName(item.type)}</span>
                    )}
                    <div className="side-box-item-date">{item.date}</div>
                </div>
                <div className="side-box-item-text">{item.text}</div>
                <a 
                    href={item.link.link} 
                    className="side-box-item-link" 
                    target={item.type === 'event' ? '_self' : '_blank'} 
                    rel="noopener noreferrer"
                    onClick={handleLinkClick}
                >
                    {item.link.text} <img src='/arrow.svg' alt="..." />
                </a>
            </div>
        </div>
    );
};

const CarouselSideBox = ({ sideBox }) => (
    sideBox && (
        <div className="carousel-side-box d-none d-lg-inline-block">
            <div className="side-box-title mb-3">
                {sideBox.title}</div>
            {sideBox.items.map((item, index) => (
                <SideBoxItem key={index} item={item} />
            ))}
            {sideBox.link && (
                <div className="side-box-footer">
                    <a className="btn btn-primary btn-sm mt-3" href={sideBox.link.link}>
                        {sideBox.link.text}
                    </a>
                </div>
            )}
        </div>
    )
);

const Carousel = (carousel) => {
    let images = carousel.images;
    if (carousel.takeRandomImageCount) {
        images = images.sort(() => 0.5 - Math.random()).slice(0, carousel.takeRandomImageCount);
    }

    const message = carousel.messages.sort(() => 0.5 - Math.random())?.[0];

    return (
        <div id={carousel.id} className="main-carousel carousel slide carousel-fade" data-bs-ride="carousel">
            <CarouselIndicators images={images} carouselId={carousel.id} />
            <div className="carousel-overlay" />
            <CarouselItems images={images} />
            <CarouselMessage message={message} />
            <CarouselSideBox sideBox={carousel.sideBox} />
        </div>
    );
};

export default Carousel;
